import Debug from 'debug';

import { loadScript } from '~/app/lib/utils/loadScript';
import fetchJson from '~/app/lib/fetchJson';
import { on } from '~/app/lib/utils/events';

const SRC = 'https://js-cdn.music.apple.com/musickit/v3/musickit.js';
const debug = Debug('songwhip/loadMusicKit');

let musicKitLoaded = false;

interface MusicKit {
  configure: (params: {
    developerToken: string;
    app: { name: string; build: string };
  }) => void;

  getInstance: () => MusicKitInstance;
}

export interface MusicKitInstance {
  authorize: () => Promise<string>;
}

const loadMusicKit = ({
  isOrchardPage,
}: {
  isOrchardPage: boolean;
}): Promise<MusicKitInstance> =>
  new Promise((resolve, reject) => {
    debug('load');

    if (musicKitLoaded) {
      resolve(window['MusicKit'].getInstance());
    }

    const off = on(document, 'musickitloaded', () => {
      debug('loaded');

      musicKitLoaded = true;

      // cleanup
      off();

      // hit our backend to get dev token
      fetchDeveloperToken({ isOrchardPage }).then(async (developerToken) => {
        const MusicKit: MusicKit = window['MusicKit'];

        try {
          await MusicKit.configure({
            developerToken,

            app: {
              name: 'Songwhip',
              build: '1978.4.1',
            },
          });

          resolve(MusicKit.getInstance());
        } catch (error) {
          reject(error);
        }
      });
    });

    loadScript({
      src: SRC,
    });
  });

const fetchDeveloperToken = async ({
  isOrchardPage,
}: {
  isOrchardPage: boolean;
}) => {
  const { json } = await fetchJson<{ data: { token: string } }>(
    `/api/appleMusic/token?isOrchardPage=${String(isOrchardPage)}`
  );

  return json.data.token;
};

export default loadMusicKit;
